/* eslint-disable semi,semi-style */
/**
 * 获取当前环境
 */
const { hostname, origin } = location;
const isLocalHost = /127\.0\.0\.1|localhost/.test(hostname);

let envir;
let prefix;

// 仅按 hostname 判断环境，避免 omni/rspack 未注入 import.meta.env 或
// OE 构建未设置 NODE_ENV=production 导致运行时崩溃或误判。
if (isLocalHost) {
  envir = 'dev';
  prefix = origin;
} else if (/open-epower\.intra\.xiaojukeji\.com/.test(hostname)) {
  envir = 'test';
  prefix = 'https://gw-test.intra.xiaojukeji.com';
} else if (/open-epower-pre\.intra\.xiaojukeji\.com/.test(hostname) || /static-pre\.am\.xiaojukeji\.com/.test(hostname)) {
  envir = 'pre';
  prefix = 'https://gw-pre.am.xiaojukeji.com';
} else if (/open-epower\.xiaojukeji\.com/.test(hostname)) {
  envir = 'online';
  prefix = 'https://gw.am.xiaojukeji.com';
}

/** 各环境前端站点 origin（setCookie url 必须与 gw 环境配对，不能用错域名） */
const SITE_ORIGIN_MAP: Record<string, string> = {
  test: 'https://open-epower.intra.xiaojukeji.com',
  pre: 'https://open-epower-pre.intra.xiaojukeji.com',
  online: 'https://open-epower.xiaojukeji.com',
};

export const env = envir;
export const host = prefix;

export function getSiteOrigin() {
  if (envir && SITE_ORIGIN_MAP[envir]) {
    return SITE_ORIGIN_MAP[envir];
  }
  return origin;
}

export const urls = {
  dev: 'https://unicorn-test.intra.xiaojukeji.com/dashboard',
  test: 'https://unicorn-test.intra.xiaojukeji.com/dashboard',
  pre: 'https://unicorn-pre.intra.xiaojukeji.com/dashboard',
  online: 'https://unicorn.xiaojukeji.com/dashboard',
};
